import { render, staticRenderFns } from "./MessageListModal.vue?vue&type=template&id=4d57841e&scoped=true"
import script from "./MessageListModal.vue?vue&type=script&lang=js"
export * from "./MessageListModal.vue?vue&type=script&lang=js"
import style0 from "./MessageListModal.vue?vue&type=style&index=0&id=4d57841e&prod&lang=scss&scoped=true"
import style1 from "./MessageListModal.vue?vue&type=style&index=1&id=4d57841e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57841e",
  null
  
)

export default component.exports